import "./style.css";
import { t } from "../../services/formatters";
import { Consenso } from "../Consenso";
import { useSession } from "../../hooks/useSession";

export const InformativeBusiness = ({}) => {
  const { read, update } = useSession();

  const scrollToNextElement = (destinationIdx = null) => {
    // default to "fissa" button
    let destinationNode = document.querySelector(".btn-txt-container");
    if (null != destinationIdx) {
      destinationNode = document.querySelectorAll(".tos-item-component")[destinationIdx];
    }
    destinationNode.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <div className="section tos-list-component">

      <div className={`section white-box input-box-component`}>
        <h3>{t("camera_commercio")}</h3>
        <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
        <Consenso
          defaultValue={read("iscrittoCameraCommercio")}
          onChange={(value) => {
            update("iscrittoCameraCommercio", value);
            scrollToNextElement(1);
          }}
          name="iscrittoCameraCommercio"
          text={""}
          optionsList={[
            {
              label: "Si, sono iscritto",
              value: "1"
            },
            {
              label: "No, non sono iscritto",
              value: "0"
            }
          ]}
          classList="reverse"
        />
      </div>

      <div className={`section white-box input-box-component`}>
        <h3>{t("tipo_azienda")}</h3>
        <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
        <Consenso
          defaultValue={read("tipoAzienda")}
          onChange={(value) => {
            update("tipoAzienda", value);
            scrollToNextElement(2);
          }}
          name="tipoAzienda"
          text={""}
          optionsList={[
            {
              label: "Società",
              value: "societa"
            },
            {
              label: "Ditta individuale",
              value: "ditta_individuale"
            }
          ]}
          classList="reverse"
        />
      </div>

      <div className="testiInformativa">
          <h3>
            {t("we_need_your_consent_title")}
          </h3>
          <p>
            {t("we_need_your_consent_2")}
          </p>
      </div>

      <div className={`section input-box-component`}>
        <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
        <Consenso
          defaultValue={read("privacyExtcommoffer")}
          onChange={(value) => {
            update("privacyExtcommoffer", value);
            scrollToNextElement(3);
          }}
          name="privacyExtcommoffer"
          text={t("tos_1")}
        />
        <Consenso
          defaultValue={read("privacyOtherservice")}
          onChange={(value) => {
            update("privacyOtherservice", value);
            scrollToNextElement(4);
          }}
          name="privacyOtherservice"
          text={t("tos_2")}
        />
        <Consenso
          defaultValue={read("privacyProfilazione")}
          onChange={(value) => {
            update("privacyProfilazione", value);
            scrollToNextElement(5);
          }}
          name="privacyProfilazione"
          text={t("tos_3")}
        />
        <p className="crea-appto-error tos-list-component-sic-appto-error text-center hidden"><br />È obbligatorio il consenso.</p>
        <Consenso
          defaultValue={read("privacyInterncommoffer")}
          onChange={(value) => {
            update("privacyInterncommoffer", value);
            scrollToNextElement();
          }}
          name="privacyInterncommoffer"
          text={t("tos_4")}
          classList="tos-sic"
        />
      </div>

    </div>
  );
};
